import { isInWebView } from '../webview/env';

/**
 * Регистрация service worker для PWA. Вызывается ТОЛЬКО из клиентского модуля,
 * поэтому PWA (установка + офлайн-кэш) доступна только в Client.
 *
 * Гейты:
 *   - только продакшн-сборка (в dev SW мешает HMR и живому обновлению);
 *   - не в webview — там приложение встроено в натив, отдельный SW и офлайн-кэш
 *     не нужны и могут конфликтовать с оболочкой;
 *   - браузер поддерживает Service Worker API.
 *
 * Сам SW и стратегии кэша: public/service-worker.js.
 */
export const registerClientServiceWorker = (): void => {
  const isProd = process.env.NODE_ENV === 'production';

  if (!isProd || isInWebView() || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((error) => {
      // Регистрация не критична для работы приложения — только логируем.
      console.error('Service worker registration failed:', error);
    });
  });
};
